"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amount = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../utils");
const Amount = ({ value, currency = '$', className }) => {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return (0, jsx_runtime_1.jsx)("span", { className: "text-fg-muted", children: "\u2014" });
    }
    const negative = value < 0;
    // 有角分時固定兩位小數（$519,600.90，不會 .9／.35 混著出現）；整數不顯示小數
    const abs = Math.round(Math.abs(value) * 100) / 100;
    const digits = Number.isInteger(abs) ? 0 : 2;
    return ((0, jsx_runtime_1.jsxs)("span", { className: (0, utils_1.cn)('whitespace-nowrap', negative && 'text-red-600 dark:text-red-400', className), children: [negative && '-', currency, abs.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: 2 })] }));
};
exports.Amount = Amount;
exports.Amount.displayName = 'Amount';
